var masonry = {
    selector: '.masonry',
    init: function () {
        var self = this,
            $masonry = $(self.selector);

        var masonry = FlexMasonry.init(self.selector, {
            breakpointCols: {
                'min-width: 520px': 2,
            },
            numCols: 1,
        });

        $masonry.imagesLoaded(function (instance) {
            var elements = instance.elements;
            masonry.refreshAll();

            for (var element in elements) {
                $(elements[element]).addClass('masonry--loaded');
            }
        });

        setTimeout(function () {
            masonry.refreshAll();
        }, 1000);

        setTimeout(function () {
            masonry.refreshAll();
        }, 3000);

        setTimeout(function () {
            masonry.refreshAll();
        }, 5000);
    },
};

export { masonry };
